import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";
import {VehicleType} from "../../../commons/types/vehicle.type";
import {CommonsService} from "../../../commons/services/commons-service.service";

export class VehiclesMultiSelectListCtrl implements IController {
  selectedIds: any;
  optionIds: any;
  excludeIds: any;
  vehicleClasses: VehicleType[]
  onChange: Function;

  private vehiclesRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private selectedKeys: any;
  private excludeKeys: any;
  public isSelectAll: boolean;

  /* @ngInject */
  constructor(private $log, private $vehicles, private $infiniteScroll, private commonsService: CommonsService) {
  }

  $onInit() {
    this.vehiclesRef = this.$vehicles();
    this.loadLimit = 20;

    this.vehiclesRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.vehiclesRef, this.loadLimit, {getFullData: true});
  }

  $onChanges(changes) {
    if (changes.selectedIds) {
      this.selectedKeys = [];
      _.forEach(this.selectedIds, (id) => {
        this.selectedKeys[id] = true;
      })
    }
    if (changes.excludeIds) {
      this.excludeKeys = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludeKeys[id] = true;
      })
    }
  }

  onToggle(id, isSelected) {
    this.onChange({
      ids: isSelected ? _.concat(this.selectedIds || [], [id]) :
        _.filter(this.selectedIds, (sid) => {
          return sid !== id;
        })
    });
  }

  submitQuery(query) {
    this.queryString = query;
    this._reload();
  }

  onToggleSelectAll() {
    if (this.isSelectAll) {
      this.onChange({ids: []});
    } else {
      this.onChange({ids: this.infiniteScroll?.getItems()?.map((vehicleType) => vehicleType.id)});
    }
  }

  isAllSelected() {
    this.isSelectAll = this.commonsService.checkIfArraysMatch(this.infiniteScroll?.getItems().map(vehicleType => vehicleType.id), this.selectedIds);
    return this.isSelectAll;
  }

  private _reload() {
    this.vehiclesRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      query: this.queryString,
      types: this.vehicleClasses,
      sort: 'name,asc'
    };
  }
}

angular
  .module('bringoz.admin.vehicles')
  .component('vehiclesMultiSelectList', {
    bindings: {
      selectedIds: '<',
      optionIds: '<?',
      excludeIds: '<?',
      vehicleClasses: '<?',
      onChange: '&'
    },
    template: require('./vehicles-multi-select-list.html').default,
    controller: VehiclesMultiSelectListCtrl
  });
